import { supabase } from '../../providers/supabase/client'

interface Client {
    first_name: string,
    last_name: string,
    email?: string,
    phone?: string,
    document_type?: string,
    document_number?: string,
    birth_date?: string,
    document_issue_date?: string,
    document_expiry_date?: string,
    departamento?: string,
    provincia?: string,
    distrito?: string,
    direccion?: string,
    status?: string,
    agent_notes?: string,
    avatar_url?: string,
    document_url?: string,
    name?: string // Optional for backward compatibility or computed
}

export const fetchClients = async () => {

    return await supabase
        .from('clients')
        .select(`
            id, created_at, first_name, last_name, name, email, phone,
            document_type, document_number, birth_date,
            document_issue_date, document_expiry_date,
            departamento, provincia, distrito, direccion,
            status, agent_notes, avatar_url, document_url,
            reservations(count)    
        `)
}

export const fetchClientsWithLocations = async () => {
    return await supabase
        .from('clients')
        .select(`
            id, first_name, last_name, departamento, provincia, status,
            reservations(status)    
        `)
}

export const fetchClientsReservations = async () => {
    return await supabase
        .from('clients')
        .select(`
            first_name,
            last_name,
            name,
            reservations (
                start_date,
                end_date,
                fee_adults,
                fee_kids,
                relocation,
                tours,
                adults,
                kids,
                places (
                    name,
                    country
                ),
                reservations_aerolines (
                    price,
                    adult_price,
                    kid_price,
                    aerolines (
                        name
                    )
                )
             
            )
        `)
}

export const createClient = async (client: Client) => {
    // Ensure name is populated if not provided, for backward compatibility
    const clientData = {
        ...client,
        name: client.name || `${client.first_name} ${client.last_name}`.trim(),
        birth_date: client.birth_date || null,
        document_issue_date: client.document_issue_date || null,
        document_expiry_date: client.document_expiry_date || null,
    };

    return await supabase
        .from('clients')
        .insert([
            clientData,
        ])
        .select()
}

export const addManyClients = async (clients: Client[]) => {
    const clientsData = clients.map(client => ({
        ...client,
        name: client.name || `${client.first_name} ${client.last_name}`.trim()
    }));

    return await supabase
        .from('clients')
        .insert(clientsData)
        .select()
}

export const updateClient = async (id: number, client: any) => {
    const { reservations, created_at, id: clientId, ...restClient } = client;
    const clientData = {
        ...restClient,
        name: client.name || `${client.first_name || ''} ${client.last_name || ''}`.trim(),
        birth_date: client.birth_date || null,
        document_issue_date: client.document_issue_date || null,
        document_expiry_date: client.document_expiry_date || null,
    };

    return await supabase
        .from('clients')
        .update(clientData)
        .eq('id', id)
        .select()
}

export const deleteClient = async (id: number) => {
    return await supabase
        .from('clients')
        .delete()
        .eq('id', id)
}
export const uploadClientMedia = async (file: File, path: string) => {
    const { error } = await supabase.storage
        .from('clients_media')
        .upload(path, file, {
            cacheControl: '3600',
            upsert: true,
        });

    if (error) {
        console.error('Error uploading to Supabase Storage:', error);
        throw error;
    }

    const { data: publicUrlData } = supabase.storage
        .from('clients_media')
        .getPublicUrl(path);

    return publicUrlData.publicUrl;
};

export const searchClientsForPalette = async (query: string) => {
    return await supabase
        .from('clients')
        .select('id, name, dni, email')
        .or(`name.ilike.%${query}%,dni.ilike.%${query}%,email.ilike.%${query}%`)
        .limit(5);
};

export const fetchPassengersByClientId = async (clientId: string | number) => {
    return await supabase
        .from('passengers')
        .select('*')
        .eq('associated_client_id', clientId);
};
